import React, { useCallback } from "react";
import { connect } from "react-redux";

import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { Button } from "@mapmycustomers/ui";

import quickImport from "@app/assets/integrations/import-illustration.svg";
import advancedSync from "@app/assets/integrations/integration-illustration.svg";
import TextWithLine from "@app/component/typography/TextWithLine";
import Path from "@app/enum/Path";
import { isOnTrialPlan } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import getContactWithIntegrationTeamLink from "@app/util/integrations/getContactWithIntegrationTeamLink";

import integrationAnalytics from "../../integrationAnalytics";
import { mapmycustomersColoredLogo } from "../../logo";
import IntegrationInfoBlock from "../IntegrationInfoBlock";

import styles from "./Links.module.scss";

interface Props {
  isTrial?: boolean;
}

const Links: React.FC<Props> = ({ isTrial }) => {
  const handleTryItOut = useCallback(() => integrationAnalytics.clicked(["Try Quick Import"]), []);
  const handleChatWithUs = useCallback(() => integrationAnalytics.clicked(["Chat With Us"]), []);
  return (
    <div className={styles.container}>
      <TextWithLine>
        <FormattedMessage
          id="integrations.links.title"
          defaultMessage="Looking for something different?"
          description="Text of links section"
        />
      </TextWithLine>
      <div className={styles.itemContainer}>
        <div className={styles.item}>
          <IntegrationInfoBlock
            action={
              <Link to={Path.IMPORT}>
                <Button onClick={handleTryItOut}>
                  <FormattedMessage
                    id="integrations.links.tryItOut"
                    defaultMessage="Try it out"
                    description="Text of Try it out button"
                  />
                </Button>
              </Link>
            }
            image={quickImport}
            text={
              <FormattedMessage
                id="integrations.links.quickImportSubTitle"
                defaultMessage="No CRM? No problem. Simply import your customer data via spreadsheet"
                description="Subtitle of Links Quick Import section"
              />
            }
            title={
              <div className={styles.title}>
                <FormattedMessage
                  id="integrations.links.quickImportTitle"
                  defaultMessage="Quick Import"
                  description="Title of Links Quick Import section"
                />
              </div>
            }
          />
        </div>
        <div className={styles.item}>
          <IntegrationInfoBlock
            action={
              <Button
                href={getContactWithIntegrationTeamLink(isTrial ?? false)}
                onClick={handleChatWithUs}
                target="_blank"
              >
                <FormattedMessage
                  id="integrations.links.chatWithUs"
                  defaultMessage="Chat with us"
                  description="Text of Chat with us button"
                />
              </Button>
            }
            image={advancedSync}
            text={
              <FormattedMessage
                id="integrations.links.mapmycustomersTitle"
                defaultMessage="Connect any system with an API to sync data with your CRM, ERP, billing system and more"
                description="Subtitle of Links Advanced Sync section"
              />
            }
            title={
              <div className={styles.mmcApi}>
                <img alt="" src={mapmycustomersColoredLogo} /> API
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  isTrial: isOnTrialPlan(state),
});

export default connect(mapStateToProps)(Links);
